import { axios } from '@axios';
import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from '../../lib/react-query';

export const getAllAgents = (params: any): Promise<any> => {
  return axios.get('/admin/vapi-agents', { params });
};

export const getAgentById = (id: string): Promise<any> => {
  return axios.get(`/admin/vapi-agents/${id}`);
};

export const getAgentUsage = (id: string, days: number = 30): Promise<any> => {
  return axios.get(`/admin/vapi-agents/${id}/usage?days=${days}`);
};

export const getAgentsStatsOverview = (days?: number, userId?: string): Promise<any> => {
  const daysParam = days ?? 30;
  const userIdParam = userId ?? '';
  return axios.get(`/admin/vapi-agents/stats/overview?days=${daysParam}&userId=${userIdParam}`);
};

type QueryFnType = typeof getAllAgents;
type SingleAgentQueryFnType = typeof getAgentById;
type AgentUsageQueryFnType = typeof getAgentUsage;
type AgentStatsOverviewQueryFnType = typeof getAgentsStatsOverview;

export const useAllAgentsQuery = ({ params, config }: { params: any; config?: QueryConfig<QueryFnType> }) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['allAgents', params],
    queryFn: () => getAllAgents(params),
    select: (res: any) => res,
    ...config,
  });
};

export const useAgentByIdQuery = ({ id, config }: { id: string; config?: QueryConfig<SingleAgentQueryFnType> }) => {
  return useQuery<ExtractFnReturnType<SingleAgentQueryFnType>>({
    queryKey: ['agent', id],
    queryFn: () => getAgentById(id),
    select: (res: any) => res,
    enabled: !!id,
    ...config,
  });
};

export const useAgentUsageQuery = ({ id, days = 30, config }: { id: string; days?: number; config?: QueryConfig<AgentUsageQueryFnType> }) => {
  return useQuery<ExtractFnReturnType<AgentUsageQueryFnType>>({
    queryKey: ['agentUsage', id, days],
    queryFn: () => getAgentUsage(id, days),
    select: (res: any) => res,
    enabled: !!id,
    ...config,
  });
};

export const useAgentsStatsOverviewQuery = ({ days = 30, userId, config }: { days?: number; userId?: string; config?: QueryConfig<AgentStatsOverviewQueryFnType> }) => {
  return useQuery<ExtractFnReturnType<AgentStatsOverviewQueryFnType>>({
    queryKey: ['agentsStatsOverview', days, userId],
    queryFn: () => getAgentsStatsOverview(days, userId),
    select: (res: any) => res,
    ...config,
  });
};
